import React, { useEffect, useState, useMemo } from "react";
import { getUpcomingBirthdays } from "../../../../api/dashboard";
import { AlertComponent } from "../../../../common/components";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { convertUTCToLocal } from "../../../../utils/utils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const UpcomingBirthdayChartSection: any = (props: any) => {
  const [upcomingBirthdays, setUpcomingBirthdays] = useState<any[]>([]);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const currentTimeZone = dayjs.tz.guess();

  function getFormattedDobText(dob: any) {
    if (!dob) return "-";

    const dobLocal = dayjs.utc(dob).tz(currentTimeZone);
    const today = dayjs().tz(currentTimeZone);
    const tomorrow = today.clone().add(1, "day");

    if (
      dobLocal.date() === today.date() &&
      dobLocal.month() === today.month()
    ) {
      return "Today";
    }

    if (
      dobLocal.date() === tomorrow.date() &&
      dobLocal.month() === tomorrow.month()
    ) {
      return "Tomorrow";
    }

    return dobLocal.format("MM/DD/YYYY");
  }

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const middleName = item?.middle_name ? item?.middle_name?.trim() : "";

    const fullName =
      firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : firstName
          ? firstName
          : middleName
            ? middleName
            : lastName
              ? lastName
              : "-";
    return fullName;
  };

  const fetchUpcomingBirthdays = async () => {
    try {
      setIsLoading(true);
      const response = await getUpcomingBirthdays();
      if (response?.status === 200) {
        const sorted = (response?.data?.data || []).sort((a: any, b: any) => {
          const aDate = dayjs.utc(a?.dob).tz(currentTimeZone);
          const bDate = dayjs.utc(b?.dob).tz(currentTimeZone);
          // Compare only month and day
          const aValue = aDate.month() * 100 + aDate.date();
          const bValue = bDate.month() * 100 + bDate.date();

          return aValue - bValue;
        });
        setUpcomingBirthdays(sorted);
      }
    } catch (error: any) {
      console.error(
        error?.response?.data?.message || "Error fetching upcoming birthdays:"
      );
      setAlertMessage(
        error?.response?.data?.message || "Error fetching upcoming birthdays"
      );
      setAlertType("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUpcomingBirthdays();
  }, []);

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <div className="dashboard-chart-section">
      <div className="dashboard-chart-section-cards birthday-chart-section">
        <div className="dashboard-chart-section-cards-header">
          <div className="dashboard-chart-section-birthday-sub-heading">
            In the next 7 days
          </div>
        </div>
        <div className="dashboard-chart-section-row-sub-cards-list birthday-dates-list">
          {upcomingBirthdays?.length > 0 ? (
            upcomingBirthdays.map((item: any, index: number) => (
              <div
                className="dashboard-chart-section-row-sub-cards birthday-card"
                key={index}
              >
                <div
                  title={fetchFullName(item)}
                  className="dashboard-chart-section-row-sub-cards-main-text dashboard-chart-section-row-sub-cards-name"
                >
                  {fetchFullName(item)}
                </div>
                <div className="dashboard-chart-section-row-sub-cards-sub-text birthday-date-text">
                  {getFormattedDobText(item?.dob)}
                </div>
              </div>
            ))
          ) : (
            <div className="dashboard-chart-section-row-sub-cards no-records-text">
              <div className="dashboard-chart-section-row-sub-cards-main-text">
                No upcoming birthdays this week.
              </div>
            </div>
          )}
        </div>
        <AlertComponent
          message={alertMessage}
          type={alertType}
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
        />
      </div>
    </div>
  );
};
export default UpcomingBirthdayChartSection;
